import Axios from "axios";
import {
  SET_MANUAL_ATTENDANCE,
  UNSET_MANUAL_ATTENDANCE,
} from "@/store/mutation-types";
import {
  saveManualAttendance,
} from "@/store/api";

const state = {
  manualAttendance: null,
};

const getters = {
  getManualAttendance(state) {
    return state.manualAttendance;
  },
};

const mutations = {
  [SET_MANUAL_ATTENDANCE](state, data) {
    state.manualAttendance = data;
  },
  [UNSET_MANUAL_ATTENDANCE](state) {
    state.manualAttendance = null;
  },
};

const actions = {
  saveManualAttendance({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.post(saveManualAttendance, data)
        .then((response) => {
          commit(SET_MANUAL_ATTENDANCE, response.data.data);
          resolve(response.data);
        })
        .catch((error) => {
          commit(UNSET_MANUAL_ATTENDANCE);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING", null, { root: true });
        });
    });
  },

  saveBulkManualAttendance({ commit }, dataArray) {
    return new Promise((resolve, reject) => {
      Axios.post(saveManualAttendance, dataArray)
        .then((response) => {
          commit(SET_MANUAL_ATTENDANCE, response.data.data);
          resolve(response.data);
        })
        .catch((error) => {
          commit(UNSET_MANUAL_ATTENDANCE);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING", null, { root: true });
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

